$(document).ready(function(){
  
  $('.marquee-left').marquee({
      direction: 'left',
      duration: 40000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });

  $(".banner_slider .banner_list").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    adaptiveHeight: true,
  });
  $(".lifestyle-photos").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    fade: true,
    adaptiveHeight: true,
    cssEase: 'linear'
  });

  $(".review-carousel").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(document).on('click','.accordion details summary',function(e) {
    e.preventDefault();
    if($(this).parent().attr('open')){
     $(this).parent().attr('open', false);
    }else{
      $('.accordion details summary').parent().attr('open', false);
      $(this).parent().attr('open', true);
    }
  });

});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.products-slider-section .product-slider').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  
  $('.products-slider-section .product-slider').slick('refresh');
  
});

$(document).on('click','.select-label', function () {
    if($(this).parent().hasClass('active')){
      $(this).parent().removeClass('active');
    }else{
      $('.dropdown').removeClass('active');
      $(this).parent().addClass('active');
    }
});
$(document).on('click','.dropdown-list li', function () {
    $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
    $(this).parents('.dropdown').removeClass('active');
    var variant_id = $(this).data('value');
    $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
});



  // Fancybox open for pdp page
// Fancybox Config
Fancybox.bind('[data-fancybox="gallery"]', {
//
 Thumbs: {
      type: ""
  },
  Image: {
        zoom: true,
        wheel: true, // Enable mouse wheel zoom
        protect: true
    }
});
